import { Box, Button, Flex, Text } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import TicketInputSm from "@components/TicketInputSm";
import UTMLink from "@components/UTMLink";
import { BRIDGE_TO_CHAIN } from "@constants/analytics";
import { BRIDGE_AGETH_OPTIONS, BRIDGE_OPTIONS } from "@constants/common";
import React from "react";
import { formatNumber, trackEvent } from "utils";
import { TChainSelection } from "./types";

const TicketInputRightSection = ({ chain }: { chain: string }) => {
  return (
    <Flex flexDir="column" alignItems="center">
      <Flex alignItems="center" justify="space-between" flex={1} gap={2}>
        <Box
          flex={1}
          fontSize={"14px"}
          fontWeight={500}
          letterSpacing={"-0.4px"}
        >
          on {chain}
        </Box>
      </Flex>
    </Flex>
  );
};

const BridgeAccordian = ({
  isAgETH = false,
  toSymbol,
  fromSymbol,
  fromChain,
  toChain,
  tokenAmount,
}: {
  isAgETH?: boolean;
  toSymbol: string;
  fromSymbol: string;
  fromChain: TChainSelection;
  toChain: TChainSelection;
  tokenAmount?: number | null;
}) => {
  const BRIDGE_CONFIG = isAgETH ? BRIDGE_AGETH_OPTIONS : BRIDGE_OPTIONS;
  const bridgeConfigFrom = BRIDGE_CONFIG.filter(
    (v) => v.id === fromChain.id
  )[0];
  const bridgeConfigTo = BRIDGE_CONFIG.filter((v) => v.id === toChain.id)[0];
  return (
    <Flex justifyContent="center" p="0">
      <Flex
        flexDir="column"
        gap="16px"
        mt={{ base: "16px", xl: "0px" }}
        w={{ base: "100%", md: "648px" }}
      >
        <Flex
          borderRadius="24px"
          bg="backgroundCard"
          p={{ base: "16px 16px 24px", md: "20px" }}
          gap="16px"
          w={"100%"}
          direction={"column"}
        >
          <Flex
            justifyContent={"space-between"}
            direction={{ base: "column", sm: "row" }}
          >
            <Flex width={{ base: "100%", sm: "45%" }} direction={"column"}>
              <TicketInputSm
                inputRightElement={
                  <TicketInputRightSection chain={bridgeConfigFrom.to} />
                }
                value={fromSymbol}
                disabled
              />
            </Flex>
            <Flex
              mt={{ base: "15px", sm: "15px" }}
              mb={{ base: "5px", sm: 0 }}
              justifyContent={"center"}
              transform={{ base: "rotate(90deg)", sm: "none" }}
            >
              <BaseImage
                src="/assets/arrow-right.svg"
                alt="swap"
                height={24}
                width={23}
                loading="eager"
              />
            </Flex>
            <Flex width={{ base: "100%", sm: "45%" }} direction={"column"}>
              <TicketInputSm
                inputRightElement={
                  <TicketInputRightSection chain={bridgeConfigTo.to} />
                }
                value={toSymbol}
                disabled
              />
            </Flex>
          </Flex>

          <Flex mt="-16px">
            {tokenAmount !== undefined && tokenAmount != null ? (
              <Text
                fontWeight="500"
                fontSize="12px"
                mt="6px"
                color="textPrimary"
              >
                Balance:{" "}
                <strong>
                  {formatNumber(Number(tokenAmount), false, 4, true)}{" "}
                  {fromSymbol}
                </strong>
              </Text>
            ) : null}
          </Flex>

          {bridgeConfigTo && bridgeConfigTo.link && (
            <UTMLink
              href={bridgeConfigTo.link}
              isExternal={true}
              onClick={() =>
                trackEvent(BRIDGE_TO_CHAIN, { chain_clicked: toChain })
              }
            >
              <Button
                borderRadius="6px"
                bg="textPrimary"
                p="20px 24px 20px 24px"
                h="42px"
                w={"100%"}
                minW="126px"
                // maxW="196px"
                _hover={{
                  bg: "textPrimary",
                }}
                onClick={() => {}}
              >
                <Flex gap="10px">
                  <Text
                    fontSize={"14px"}
                    lineHeight={"18px"}
                    fontWeight={500}
                    color="backgroundCard"
                  >
                    Go to Bridge{" "}
                  </Text>
                  <Box borderRadius={"50px"} overflow={"hidden"}>
                    <BaseImage
                      width={18}
                      height={18}
                      alt={""}
                      src={bridgeConfigFrom.icon}
                    />
                  </Box>
                </Flex>
              </Button>
            </UTMLink>
          )}

          <Flex justifyContent={"center"}>
            <Text
              fontSize={"10px"}
              fontWeight={400}
              lineHeight="16px"
              color={"#A1B6BA"}
            >
              Est. time to bridge: ~10 Mins
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default BridgeAccordian;
